import { memo } from 'react';

function DownloadPdfIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="28"
			height="28"
			fill="none"
			viewBox="0 0 28 28"
		>
			<path
				stroke="#444"
				strokeLinecap="round"
				strokeWidth="2"
				d="M14.133 19.858L6.88 12.6M14.123 19.858l7.253-7.258M14.165 1.4v16.347"
			></path>
			<path
				stroke="#444"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M2.8 25.2h22.4"
			></path>
		</svg>
	);
}

export default memo(DownloadPdfIcon);
